import { Box } from '@chakra-ui/react';
import InfiniteScroll, {
  Props as InfiniteScrollProps,
} from 'react-infinite-scroll-component';
import { STICKY_TABLE_CLASS } from './constants';

export const StickyTableBodyWrapper = ({
  children,
  infiniteScrollProps,
}: {
  children: React.ReactNode;
  infiniteScrollProps?: InfiniteScrollProps;
}) => {
  if (infiniteScrollProps) {
    return (
      <InfiniteScroll
        {...infiniteScrollProps}
        className={STICKY_TABLE_CLASS}
        style={{
          overflowY: 'hidden',
        }}
      >
        {children}
      </InfiniteScroll>
    );
  }

  return (
    <Box overflowX="auto" overflowY="hidden" className={STICKY_TABLE_CLASS}>
      {children}
    </Box>
  );
};
